<template>
    <div class="pa-3 grey lighten-4">
    <v-card class="card--flex-toolbar">
      <v-card-text class="pa-0">
          <TransactionList></TransactionList>
      </v-card-text>
    </v-card>
    </div>
</template>
<script>
import TransactionList from '@/pages/transaction/List';
export default {
    name: "CompanyInvoice",
    components: {
        TransactionList
    }
}
</script>
